export enum JourneyType {
  ApplianceCare = 'appliance-care',
  MultiPlan = 'multi-plan',
  RegOnly = 'reg-only',
  SingleMultiPlan = 'single-multi-plan',
  SinglePlan = 'single-plan',
}
